import { render, staticRenderFns } from "./CartControl.vue?vue&type=template&id=84fd85de"
import script from "./CartControl.vue?vue&type=script&lang=js"
export * from "./CartControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports